// extracted by mini-css-extract-plugin
module.exports = {"container":"_1BCG5k3ZjleZ_9bhCEFpxO","p":"_1JvZ1jSLQ3Kjf20KEz9--z","okBtn":"_3sWiKxP5zYag3ttOx5vvwB","cancelBtn":"_18DBBsz1BuHGs0aYeW6JfT"};